import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import { previousCallIdSelector } from 'features/call/vrs-call-comments/store';
import { CallIdBase } from 'features/ui/call-id';

export const CallIdPrevious = () => {
  const previousCallId = useAppSelector(previousCallIdSelector);
  const { t } = useTranslation('translation', { keyPrefix: 'callId' });

  return <CallIdBase value={previousCallId} title={t('previousCallId')} />;
};
